//#region src/assets/smartphone-failed.png
var smartphone_failed_default = "" + new URL("smartphone-failed-rsdjjAGt.png", import.meta.url).href;
//#endregion
export { smartphone_failed_default as default };

//# sourceMappingURL=smartphone-failed.js.map